import { CreateNewMessageLayout } from './components/create-new-message-layout';
import { BasketProvider } from './hooks/use-basket';
import { CreateNewMessageProvider } from './hooks/use-create-new-message';

export const ViewCreateNewMessage = () => {
	return (
		<BasketProvider>
			<CreateNewMessageProvider>
				<CreateNewMessageLayout />
			</CreateNewMessageProvider>
		</BasketProvider>
	);
};
